import Input from '../../../components/UIElements/Input';
import { useState } from 'react';

const TicketUpdateModal = ({
  onCancel,
  pos_ticket_id,
  onSubmit,
  onChange,
}) => {
  return (
    <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full">
          <Input
            placeholder="POS Ticket ID e.g: 123456"
            label="POS Ticket ID"
            name="pos_ticket_id"
            onChange={onChange}
            value={pos_ticket_id}
          />
        </div>
      </div>
      <div className="-mx-3 flex flex-wrap gap-y-4">
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onCancel}
            className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
          >
            Cancel
          </button>
        </div>
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onSubmit}
            className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
          >
            Update Ticket
          </button>
        </div>
      </div>
    </div>
  );
};
export default TicketUpdateModal;
